import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_navigation_view_type.js";
//#region src/menu_navigation_view_type_helper.ts
var menu_navigation_view_type_helper_exports = /* @__PURE__ */ __exportAll({
	isSide: () => isSide,
	name: () => name
});
function name(value) {
	switch (value) {
		case "top": return "Top";
		case "side": return "Side";
		case "top-and-side": return "Top and Side";
	}
}
function isSide(value) {
	return value === "side" || value === "top-and-side";
}
//#endregion
export { isSide, menu_navigation_view_type_helper_exports, name };

//# sourceMappingURL=menu_navigation_view_type_helper.js.map